import { UTM_KEYS } from "@greenflagdate/shared";
import { Req } from "@larner.dev/req";

export const apiReq = new Req(import.meta.env.VITE_API_URL!);
apiReq.headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
};
for (const key of UTM_KEYS) {
  const val = sessionStorage.getItem(key);
  if (val) {
    apiReq.headers[key] = val;
  }
}
